import { PositionsModel } from "./positions";

export class EmployerSponsorDetails {
  knowPositions: string = '';
  positions = new Array<PositionsModel>();
}